// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"46e2b808","615":"ed103e46","787":"ceffe7f5"}[chunkId] + ".chunk.js";
};